import { Container } from '@angular/compiler/src/i18n/i18n_ast';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { ContractAssignor } from 'src/app/models/contract-assignor';
import { GroupRascunho, ProdutoRascunho } from 'src/app/models/group';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { GroupService } from 'src/app/services/group/group.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';

@Component({
  selector: 'app-grupo-beneficios',
  templateUrl: './grupo-beneficios.component.html',
  styleUrls: ['./grupo-beneficios.component.css']
})
export class GrupoBeneficiosComponent implements OnInit {

    public currentUser: Auth;
    public beneficios: CedenteContrato[];
    public contractAssignor: ContractAssignor[];
    public isEmpty = false;
    public rascunho: GroupRascunho;
    public step: number;
    public categoriaProduto = CategoriaProduto;

    constructor(private router: Router, private contratoService: ContratoService,
                private alertService: NewAlertService, private authenticationService: AuthenticationService,
                private groupService: GroupService) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.rascunho = this.groupService.getRascunho();

        if (this.rascunho.products) {
            this.step = 2;
        } else {
            this.step = 2;
        }

        this.loadBenefits();
    }

    next() {
        const selecionados = this.contractAssignor.filter(x => x.selected);
        if(selecionados.length <= 1){
            this.alertService.error("Selecione ao menos um benefício!");
            return;
        }
        if (!this.rascunho.products) {
            this.rascunho.products = [];
        }

        if(this.rascunho.isEdicao){
            this.rascunho.products.forEach(element => {
                selecionados.forEach(item => {
                    if(element.produtoId == item.productEligibility.product.produtoId){
                        item.standardValue = parseFloat(element.value);
                        item.standardPeriodId = element.standardPeriodCard;
                    }
                    this.rascunho.products = this.rascunho.products.filter(x => x.produtoId !== item.productEligibility.product.produtoId);
                    const produto = new ProdutoRascunho(item.productEligibility.product.produtoId, item.productEligibility.product.produtoGuid,
                    item.standardPeriodId, item.standardValue.toString(), item.maximumValue, item.productEligibility.product.corProduto, item.productEligibility.product.iconeProduto,
                    item.productEligibility.product.descricaoProduto, item.productEligibility.product.importante, item.productEligibility.product.categoriaProduto);
                    this.rascunho.products.push(produto);
                });
            });
        }
        else{
            selecionados.forEach(item => {
                this.rascunho.products = this.rascunho.products.filter(x => x.produtoId !== item.productEligibility.product.produtoId);
                const produto = new ProdutoRascunho(item.productEligibility.product.produtoId, item.productEligibility.product.produtoGuid,
                item.standardPeriodId, item.standardValue.toString(), item.maximumValue, item.productEligibility.product.corProduto, item.productEligibility.product.iconeProduto,
                item.productEligibility.product.descricaoProduto, item.productEligibility.product.importante, item.productEligibility.product.categoriaProduto);
                this.rascunho.products.push(produto);
            });
        }
        this.rascunho.products = this.rascunho.products.filter(x => {
            return selecionados.some(y => y.productEligibility.product.produtoId === x.produtoId);
        });

        this.groupService.setRascunho(this.rascunho);
        this.router.navigate(['portal/grupos/regras']);
    }

    activate(item: ContractAssignor) {
        const contrato = this.contractAssignor.find(x => x.id === item.id && item.productEligibility.product.categoriaProduto !== 2);
        contrato.selected = !contrato.selected;
    }

    loadBenefits() {
        this.contratoService.getContracts(this.currentUser.token.assignorGuid).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
                const productsToRemove = [this.categoriaProduto.Incentivo,this.categoriaProduto.IncentivoPlus,this.categoriaProduto.TradicionalPlus,this.categoriaProduto.SeuValeLog];
                this.contractAssignor = response.result;
                this.contractAssignor = this.contractAssignor.filter(item => !productsToRemove.includes(item.productEligibility.product.categoriaProduto))
                if (this.contractAssignor.length <= 0) {
                    this.isEmpty = true;
                } else {
                    this.contractAssignor.forEach(item => {
                    if (this.rascunho.products && this.rascunho.products.some(x => x.produtoId === item.productEligibility.product.produtoId) || item.productEligibility.product.categoriaProduto === this.categoriaProduto.Flex) {
                        item.selected = true;
                    }
                    });
                    this.contractAssignor = this.contractAssignor.sort((x) => {
                        if(x.selected === true){return -1;}
                        else {return 1;}
                    });
                }
            } else {
                this.alertService.error(response.message);
            }
        },
        error => {
            this.alertService.error('Erro ao carregar os contratos do cedente' + error);
        }
        );
    }
}
